import { render } from "./TheResources.vue?vue&type=template&id=290af374"
import script from "./TheResources.vue?vue&type=script&lang=js"
export * from "./TheResources.vue?vue&type=script&lang=js"

import exportComponent from "E:\\[FreeCourseSite.com] Udemy - Vue - The Complete Guide (w Router, Vuex, Composition API)\\10 - Course Project The Learning Resources App\\014 prj-cmp-01-starting-setup\\prj-cmp-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__